<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <div id="polygon-label-map" class="map-margins"></div>
  </div>
</template>

<script>
import loadGoogleMapsApi from "load-google-maps-api";
import Loading from "vue-loading-overlay";
import Axios from "axios";
export default {
  name: "CreateGoefenceV2",
  data() {
    return {
      map: null,
      polygonCoords: [],
      polygonShape: null,
      newMap: null,
      newShape_: null,
      drawManager: null,
      isLoading: false,
      fullPage: true,
      polygons: [],
    };
  },
  methods: {
    loadDrawingTools() {
      const { google } = window;
      this.drawManager = new google.maps.drawing.DrawingManager({
        drawingMode: "polygon",
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_LEFT,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON],
        },
        polygonOptions: {
          draggable: false,
          editable: true,
          fillColor: "green",
          fillOpacity: 0.5,
          strokeColor: "green",
          zIndex: 100,
        },
      });

      this.drawManager.setMap(this.map);
      let vm = this;

      google.maps.event.addListener(
        vm.drawManager,
        "overlaycomplete",
        function (event) {
          vm.drawManager.setOptions({ drawingMode: null });
          vm.drawManager = event.overlay;
          vm.updatePolygonCoordsState();

          vm.drawManager.getPaths().forEach((path) => {
            // update(vm.drawManager);
            vm.updatePolygonCoordsState();
            google.maps.event.addListener(path, "insert_at", () => {
              vm.updatePolygonCoordsState();
            });
            google.maps.event.addListener(path, "remove_at", () => {
              vm.updatePolygonCoordsState();
            });
            google.maps.event.addListener(path, "set_at", () => {
              vm.updatePolygonCoordsState();
            });
          });
        }
      );
    },
    updatePolygonCoordsState() {
      const allPolygonCoords = this.drawManager.getPath();
      const coordsToSet = [];
      for (let i = 0; i < allPolygonCoords.length; i++) {
        const data = {
          lat: allPolygonCoords.getAt(i).lat(),
          lng: allPolygonCoords.getAt(i).lng(),
        };
        data && coordsToSet.push(data);
      }
      this.polygonCoords = coordsToSet;
      this.$emit("polygonCoords", this.polygonCoords);
    },
    initializeMap() {
      const mapZoom = 4;
      const { google } = window;
      const mapOptions = {
        zoom: mapZoom,
        mapTypeId: this.geoObject.mapType,
        center: new google.maps.LatLng({ lat: 23, lng: 57 }),
        mapTypeControl: true,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT,
        },
      };
      this.map = new google.maps.Map(
        document.getElementById("polygon-label-map"),
        mapOptions
      );
      this.$emit("theMap", this.map);

      if (this.selectedGeo.length === 0 && !this.editGeo.id) {
        this.$emit("showAutocomplete");
        this.loadDrawingTools();

        // if (!this.editGeo.id) {
        this.geofence.map(({ latlngs, color, name }, i) => {
          let paths = latlngs;
          let fence = `fence${i + 1}`;
          fence = new google.maps.Polygon({
            paths: paths,
            strokeColor: color,
            map: this.map,
            strokeWeight: 3,
            fillColor: color,
            fillOpacity: 0.3,
            label: name,
            zIndex: 99,
            editable: false,
            draggable: false,
          });
          fence.setMap(this.map);
        });
        // }
      }
    },
  },
  mounted() {
    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    }).then(async () => {
      this.initializeMap();
    });
  },
  props: {
    location: String,
    geofence: Array,
    geoObject: {
      type: Object,
    },
    reset_map: Boolean,
    place: Object,
    editGeo: Object,
    selectedGeo: Array,
  },
  components: {
    Loading,
  },
  watch: {
    polygonCoords: {
      handler: function () {
        this.$emit("polygonCoords", this.polygonCoords);
      },
    },
    location: {
      handler: function () {
        if (!this.location) return;
        const { google } = window;
        this.isLoading = true;
        if (this.drawManager) this.drawManager.setMap(null);

        let apiPath = "https://nominatim.openstreetmap.org/search.php";

        let params = {
          q: this.location,
          polygon_geojson: 1,
          format: "jsonv2",
        };

        // If the place has a geometry, then present it on a map.
        if (this.place.geometry.viewport) {
          this.map.fitBounds(this.place.geometry.viewport);
        } else {
          this.map.setCenter(this.place.geometry.location);
          this.map.setZoom(17);
        }

        Axios.get(apiPath, { params: params }).then((response) => {
          let array = [];
          response.data.map((res) => {
            if (res.geojson.type === "Polygon") {
              const isReverse = res.geojson.coordinates.map((items) => {
                return items.map((item) => ({
                  lat: item[1],
                  lng: item[0],
                }));
              });
              array.push(isReverse);
            }
          });
          var merged = [].concat.apply([], array);

          if (merged.length < 1) {
            this.isLoading = false;
            this.loadDrawingTools();
            return this.$emit("locationNotFound");
          }

          this.polygonCoords = merged;

          const tempBounds = new google.maps.LatLngBounds();

          for (const element of this.polygonCoords[0]) {
            const x = {
              lat: element.lat,
              lng: element.lng,
            };
            const BoundLatLng = new google.maps.LatLng({
              lat: parseFloat(x.lat),
              lng: parseFloat(x.lng),
            });
            tempBounds.extend(BoundLatLng);
          }
          const centroid = tempBounds.getCenter();

          this.drawManager = new google.maps.Polygon({
            paths: this.polygonCoords,
            strokeColor: "green",
            map: this.map,
            strokeWeight: 3,
            fillColor: "green",
            fillOpacity: 0.3,
            zIndex: 99999,
            editable: true,
            draggable: false,
          });

          this.drawManager.setMap(this.map);
          this.map.setCenter(centroid);

          this.map.setZoom(13);

          this.drawManager.getPaths().forEach((path) => {
            this.updatePolygonCoordsState();
            google.maps.event.addListener(path, "insert_at", () => {
              this.updatePolygonCoordsState();
            });

            google.maps.event.addListener(path, "remove_at", () => {
              this.updatePolygonCoordsState();
            });

            google.maps.event.addListener(path, "set_at", () => {
              this.updatePolygonCoordsState();
            });
          });
          this.isLoading = false;
        });
      },
    },
    geoObject: {
      handler: function () {
        this.drawManager.setOptions({
          strokeColor: this.geoObject.color,
          fillColor: this.geoObject.color,
        });
        this.map.setMapTypeId(this.geoObject.mapType);
      },
    },
    reset_map: {
      handler: function () {
        this.drawManager.setMap(null);
        this.$emit("polygonCoords", []);
        this.loadDrawingTools();
      },
    },
    geofence: {
      handler: function () {
        this.selectedGeo.length === 0 && this.initializeMap();
      },
    },
    editGeo: {
      handler: async function () {
        if (this.editGeo?.latlngs?.length > 0) {
          this.isLoading = true;

          // Simulate loading delay
          await new Promise((resolve) => setTimeout(resolve, 3000));

          const { google } = window;
          // Clear existing shapes
          if (this.drawManager) {
            this.drawManager.setMap(null);
          }

          if(this.polygons.length > 0) {
            this.polygons.forEach((polygon) => {
              polygon.setMap(null);
            });
            this.polygons = [];
          }
          

          // Update the map with a new polygon
          const tempBounds = new google.maps.LatLngBounds();
          this.polygonCoords = this.editGeo.latlngs;

          for (const element of this.polygonCoords) {
            const x = {
              lat: element.lat,
              lng: element.lng,
            };
            const boundLatLng = new google.maps.LatLng({
              lat: parseFloat(x.lat),
              lng: parseFloat(x.lng),
            });
            tempBounds.extend(boundLatLng);
          }

          const drawManager = new google.maps.Polygon({
            paths: this.polygonCoords,
            strokeColor: this.editGeo.color,
            map: this.map,
            strokeWeight: 3,
            fillColor: this.editGeo.color,
            fillOpacity: 0.3,
            zIndex: 99999,
            editable: true,
            draggable: false,
          });

          drawManager.setMap(this.map);
          this.drawManager = drawManager;
          const bounds = new google.maps.LatLngBounds();
          if (this.drawManager.getPath()) {
            this.drawManager.getPath().forEach((latlng) => {
              bounds.extend(latlng);
            });
          }

          this.map.fitBounds(bounds);

          this.drawManager.getPaths().forEach((path) => {
            this.updatePolygonCoordsState();
            google.maps.event.addListener(path, "insert_at", () => {
              this.updatePolygonCoordsState();
            });

            google.maps.event.addListener(path, "remove_at", () => {
              this.updatePolygonCoordsState();
            });

            google.maps.event.addListener(path, "set_at", () => {
              this.updatePolygonCoordsState();
            });
          });

          this.isLoading = false;
        }
      },
      deep: true,
      immediate: true,
    },
    selectedGeo: {
      handler: async function (newVal, oldVal) {
        if (newVal.length > 0) {
          if (!oldVal) {
            this.isLoading = true;

            // Simulate loading delay
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }

          const { google } = window;
          // Clear existing polygons
          this.polygons.forEach((polygon) => {
            polygon.setMap(null);
          });
          if (this.drawManager) {
            this.drawManager.setMap(null);
          }
          this.polygons = [];

          // Add new polygons to the map
          newVal.forEach((geoObject) => {
            const polygon = new google.maps.Polygon({
              paths: geoObject.latlngs,
              strokeColor: geoObject.color,
              strokeWeight: 2,
              fillColor: geoObject.color,
              fillOpacity: 0.5,
              zIndex: 100,
              editable: false,
              draggable: false,
            });

            polygon.setMap(this.map);
            this.polygons.push(polygon);
          });

          // Optionally, fit the map bounds to show all polygons
          if (this.polygons.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            this.polygons.forEach((polygon) => {
              console.log(polygon.getPath());
              if (polygon.getPath()) {
                polygon.getPath().forEach((latlng) => {
                  bounds.extend(latlng);
                });
              }
            });
            this.map.fitBounds(bounds);
          }

          if (!oldVal) {
            this.isLoading = false;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* .header-margins {
  margin-left: 30px;
  margin-top: 20px;
} */
.map-margins {
  /* height: 300px;
  width: 500px;
  margin: 20px 30px; */
  height: 100vh;
  /* width: 500px; */
  /* margin: 20px 30px; */
}
/* .np-credits {
  margin-left: 30px;
  margin-top: 4px;
  font-size: 12px;
} */
</style>
